<div class="about-us-page" [class.about-us-page--embedded]="embedded">
  <app-spinner *ngIf="isLoading"></app-spinner>
  <div class="container">
    <div class="content-wrapper" *ngIf="!isLoading">
      <div *ngIf="content" class="content-body" [innerHTML]="content"></div>
      <app-no-data *ngIf="!content"
        [title]="'No About Us Available'"
        [subtitle]="'The about us content is not available at this time.'">
      </app-no-data>
    </div>
  </div>
</div>